import { render, staticRenderFns } from "./AirportCard.vue?vue&type=template&id=1a1e0b57&"
import script from "./AirportCard.vue?vue&type=script&lang=js&"
export * from "./AirportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports